import React from 'react';

const CardHeader = (props) => {

    const { titulo, monto, style, icon } = props;

    return (

        <div className="ui cards card-container" >
            <div className="dashboard-card" style={{ borderLeft: `5px solid ${style}` }}>
                <div className="ui grid container-grid">
                    <div className="ten wide column">
                        <div className="header"><h5>{titulo}</h5></div>
                        <div className="meta"> <strong> {monto} </strong> </div>
                    </div>
                    <div className="six wide column container-icon" >
                        {
                            icon !== null && (
                                <i className={`${icon} icon`} style={{ fontSize: "2em" }}></i>
                            )
                        }
                    </div>
                </div>
            </div>
        </div>

    )

}

export default (CardHeader);